import {Request} from "../core/request";
import {AuthHeader} from "../core/token";

export interface userGroup {
    id: number
    name: string
}

export async function getUserGroups() {
    return await Request.get("/academics/groups/", {headers: AuthHeader()});
}

export async function getUserGroup(groupId: number) {
    return await Request.get(`/academics/groups/${groupId}`, {headers: AuthHeader()});
}

export async function createUserGroups(newGroupName: string) {
    return await Request.post("/academics/groups/", {name: newGroupName}, {headers: AuthHeader()});
}

export async function deleteUserGroups(groupId: number) {
    return await Request.delete(`/academics/groups/${groupId}`, {headers: AuthHeader()});
}

export async function addUserToGroups(groupId: number, userId: number) {
    return await Request.post(`/academics/groups/add-user`, {group_id: groupId, user_id: userId}, {
        headers: AuthHeader()
    });
}

export async function removeUserFromGroups(groupId: number, userId: number) {
    return await Request.post(`/academics/groups/remove-user`, {group_id: groupId, user_id: userId}, {
        headers: AuthHeader()
    });
}
